module.exports = Jsw.skinUrl + "/images/sticker-collection/burst/star.png?7c6af89d5d3e3bc82c8fe817a0ef3709";